[
  {
    "slug": "chandas-shastra",
    "eyebrow": "Sanskrit metre & prosody",
    "title": "Chandas Shastra",
    "summary": "Learn the rhythm of Sanskrit, reveal a verse’s metre and compose one pāda at a time—with interactive lessons and live pattern guidance.",
    "category": "Verse & prosody",
    "tags": [
      "Metre",
      "Learn",
      "Compose"
    ],
    "aliases": "chanda chhandas chandas śāstra shastra Sanskrit poetry prosody meter metre scansion syllable laghu guru gana gaṇa matra mātrā lessons learning composition writing छन्दः अनुष्टुभ् मालिनी",
    "availability": "Detect · Learn · Compose",
    "path": "/learning-apps/chandas-shastra/"
  },
  {
    "slug": "jyotir-vidya",
    "eyebrow": "Indic Sky Lab",
    "title": "Jyotir Vidya",
    "summary": "Follow the Moon to explore tithi, nakshatra and pada. Choose a real date and timezone, or learn through a guided geometric simulation.",
    "category": "Lunar astronomy",
    "tags": [
      "Tithi",
      "Nakshatra",
      "Real dates"
    ],
    "aliases": "Indic Sky Lab jyotir vidya jyotiṣa jyotisha moon sun lunar pada phases astronomy stars date timezone nakṣatra tithi नक्षत्र तिथि",
    "availability": "Explore · Learn",
    "path": "/learning-apps/jyotir-vidya/"
  }
]
